import { Cartao } from '../componentes/Cartao.js';
import { EstadoVazio } from '../componentes/EstadoVazio.js';
import { IconeConfiguracoes } from '../componentes/Icones.js';
import { Pagina } from '../componentes/Pagina.js';

type Props = {
  readonly secao: string;
  readonly titulo: string;
  /** Tarefa do backlog que traz a tela — o supervisor vê que existe plano. */
  readonly tarefa: string;
};

/**
 * Seção já presente na navegação, com a tela ainda por vir.
 *
 * Aparece porque a barra lateral do sistema de design lista as nove seções
 * desde o primeiro dia; esconder o item faria a navegação mudar de forma a
 * cada entrega.
 */
export function EmBreve({ secao, titulo, tarefa }: Props) {
  return (
    <Pagina contexto={secao} titulo={titulo}>
      <Cartao semRespiro>
        <EstadoVazio
          tom="neutro"
          icone={<IconeConfiguracoes tamanho={28} />}
          titulo={`${titulo} entra em uma próxima entrega.`}
          detalhe={`Planejada em ${tarefa} do backlog do projeto.`}
        />
      </Cartao>
    </Pagina>
  );
}
